var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#666687"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0941 21.8493V19.8108C14.0941 19.2905 14.519 18.8686 15.0432 18.8686L16.9593 18.8686C17.211 18.8686 17.4524 18.9679 17.6304 19.1446C17.8084 19.3213 17.9084 19.5609 17.9084 19.8108V21.8493C17.9068 22.0656 17.9923 22.2737 18.1458 22.4272C18.2994 22.5807 18.5083 22.6671 18.7262 22.6671H20.0335C20.644 22.6686 21.2301 22.429 21.6623 22.0009C22.0946 21.5729 22.3376 20.9917 22.3376 20.3856V14.5783C22.3376 14.0887 22.1189 13.6243 21.7406 13.3102L17.2936 9.78432C16.52 9.16611 15.4116 9.18607 14.6612 9.83173L10.3156 13.3102C9.91939 13.615 9.6826 14.0808 9.6709 14.5783V20.3797C9.6709 21.643 10.7025 22.6671 11.975 22.6671H13.2524C13.7051 22.6671 14.0729 22.3046 14.0762 21.8552L14.0941 21.8493Z",
    fill: "#666687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.bacfa01dd63f291821eeadfab1d824c5.svg";
export { ForwardRef as ReactComponent };